import { QueryClient } from '@tanstack/react-query';

// Each SPA app calls createQueryClient() in its own main.tsx so every app owns
// its own cache instance. `defaultOptions` are copied verbatim from the original
// apps/web singleton — behavior is unchanged.
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          const status = (error as { status?: number } | null)?.status ?? 0;
          if (status >= 400 && status < 500) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
